import { useEffect, useRef } from "react";

export default function DisplayAnimate({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (ref && ref.current) {
        (ref.current as any).classList.remove("opacity-0");
      }
    }, 1);
  }, []);

  return (
    <section ref={ref} className="transition-opacity duration-1000 ease-in opacity-0">
      {children}
    </section>
  );
}
